module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[3]246.5a21c4d.woff2";